import { ArrowUpRight } from "lucide-react";
import { IMAGES, openChat } from "@/config/site";
import { Reveal, SectionHeading } from "./Motion";

const CATS = [
  { id: "residential", title: "Residential", hi: "For Homes", img: IMAGES.family, chips: ["Independent House", "Farm House", "Apartment"] },
  { id: "commercial", title: "Commercial", hi: "Shops & Institutions", img: IMAGES.school, chips: ["School & College", "Poultry Farm", "Petrol Pump", "Hospital", "Shop/Store", "Hotel"] },
  { id: "industrial", title: "Industrial", hi: "Factories & Mills", img: IMAGES.textile, chips: ["Textile Factory", "Manufacturing", "Cold Storage", "Rice/Flour Mill"] },
];

const TILES = [
  { id: "poultry", label: "Poultry Farm", img: IMAGES.poultry },
  { id: "petrol", label: "Petrol Pump", img: IMAGES.petrol },
  { id: "hospital", label: "Hospital", img: IMAGES.hospital },
  { id: "cold-storage", label: "Cold Storage", img: IMAGES.coldStorage },
  { id: "rice-mill", label: "Rice / Flour Mill", img: IMAGES.riceMill },
];

const CatCard = ({ c }) => (
  <div data-testid={`category-card-${c.id}`} className="glass card-lift group flex h-full flex-col overflow-hidden rounded-3xl">
    <div className="relative h-60 sm:h-64 overflow-hidden">
      <img src={c.img} alt={c.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent" />
      <div className="absolute bottom-4 left-6">
        <h3 className="font-display text-3xl font-bold text-white">{c.title}</h3>
        <p className="text-lg font-semibold text-gold-light">{c.hi}</p>
      </div>
    </div>
    <div className="flex flex-1 flex-col p-6">
      <div className="flex flex-wrap gap-2">
        {c.chips.map((ch) => (
          <span key={ch} className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-[15px] text-slate-700">{ch}</span>
        ))}
      </div>
      <button onClick={openChat} data-testid={`category-enquire-${c.id}`} className="mt-auto pt-6 inline-flex items-center gap-1.5 self-start text-[16px] font-semibold text-gold-ink hover:text-gold-light">
        Get Quote <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </div>
  </div>
);

export const Categories = () => (
  <section id="categories" data-testid="categories-section" className="section-pad relative bg-cream-100">
    <div className="absolute inset-0 grid-lines opacity-60" />
    <div className="relative container-x">
      <SectionHeading eyebrow="Categories" title="Solar for Every Space" />
      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {CATS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.12}>
            <CatCard c={c} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16">
        <p className="text-sm font-semibold uppercase tracking-[0.22em] text-slate-500">We Power</p>
        <div className="no-scrollbar mt-5 -mx-5 flex snap-x gap-4 overflow-x-auto px-5 sm:mx-0 sm:grid sm:grid-cols-5 sm:px-0">
          {TILES.map((t) => (
            <div key={t.id} data-testid={`project-tile-${t.id}`} className="group relative h-48 w-[70vw] shrink-0 snap-start overflow-hidden rounded-2xl sm:w-auto">
              <img src={t.img} alt={t.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent" />
              <span className="absolute bottom-3 left-4 text-lg font-semibold text-white">{t.label}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
